var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendTo = function SvgSendTo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99999 3.60002C3.77908 3.60002 3.59999 3.77911 3.59999 4.00002V20C3.59999 20.2209 3.77908 20.4 3.99999 20.4H20C20.2209 20.4 20.4 20.2209 20.4 20V13H21.6V20C21.6 20.8837 20.8836 21.6 20 21.6H3.99999C3.11634 21.6 2.39999 20.8837 2.39999 20V4.00002C2.39999 3.11637 3.11634 2.40002 3.99999 2.40002H11V3.60002H3.99999ZM19.5515 3.60002H13.5V2.40002H21.6V10.5H20.4V4.44855L12.4243 12.4243L11.5757 11.5758L19.5515 3.60002Z"
  })));
};
export default SvgSendTo;